

import { format } from "date-fns";
import { getKiinteistoSasToken } from "../../../api/api";

import { 
  bottomMarginItemGlobal,
}  from "../../utils/pdfConstants";


/**
 * Render signature block for pdfMake
 *
 * @param {Object} params
 * @param {Object} params.data - The block data containing signatures
 * @param {Array} params.content - pdfMake content array
 */
export async function renderSignatureBlock({ data, content }) {
  const signatures = Array.isArray(data?.value) ? data.value : [];

  if (signatures.length === 0) {
    content.push({
      text: "Allekirjoituksia ei ole saatavilla.",
      style: "paragraph",
      margin: [0, 5, 0, 10],
      italics: true,
      color: "#666",
    });
  }

  for (const sig of signatures) {
    let base64 = null;

    try {
      if (sig.azure_blob_name && typeof getKiinteistoSasToken === "function") {
        const res = await getKiinteistoSasToken(sig.azure_blob_name);
        const sasUrl = res?.data?.sasUrl;
        if (sasUrl) {
          const response = await fetch(sasUrl);
          if (response.ok) {
            const blob = await response.blob();
            base64 = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
          }
        }
      }
    } catch (err) {
      console.error("Failed to fetch signature image:", sig.azure_blob_name, err);
    }

    const formattedDate = sig.date ? format(new Date(sig.date), "dd.MM.yyyy") : "—";
    const name = sig.user?.nimi || "—";
    const title = sig.user?.ammattinimike || "—";
    const phone = sig.user?.puhelinnumero || "—";
    const email = sig.user?.sahkoposti || "—";

    content.push({
      stack: [
        // Date
        { text: formattedDate, alignment: "left", style: "paragraph" },

        // Signature image
        base64
          ? { image: base64, width: 150, alignment: "left", margin: [0, 0, 0, bottomMarginItemGlobal] }
          : { text: "Allekirjoituskuvaa ei saatavilla", italics: true, color: "#666", margin: [0, 0, 0, bottomMarginItemGlobal] },

        // User info
        {
          stack: [
            { text: name, style: "paragraph", margin: [0, 0, 0, 0] },
            { text: title, style: "paragraph", margin: [0, 0, 0, 0] },
            { text: phone, style: "paragraph", margin: [0, 0, 0, 0] },
            { text: email, style: "paragraph", margin: [0, 0, 0, 0] },
          ],
          margin: [0, 0, 0, bottomMarginItemGlobal],
        },
      ],
      margin: [0, 5, 0, 0],
      unbreakable: true,
    });
  }

}